module.exports = __webpack_public_path__ + "assets/df93364355ec215a60c3a960e71fbf50.jpg";